<template>
  <div class="product-wrap">
    <div class="outer">
      <div class="content">
        <img :src="content">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    content() {
      return require(`@/assets/images/products/1-${this.$i18n.locale}.jpg`);
    }
  }
};
</script>

<style lang="stylus" scoped>
.product-wrap {
  margin-top: -2.5em;
  background-color: #eee;

  .outer {
    height: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;

    .content {
      width: 100%;

      img {
        display: block;
        margin: 0 auto;
      }
    }
  }
}
</style>
